import { render, staticRenderFns } from "./ClientTransferCourseModal.vue?vue&type=template&id=075a4ca3&"
import script from "./ClientTransferCourseModal.vue?vue&type=script&lang=js&"
export * from "./ClientTransferCourseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports